import moment from 'moment';

const makeLeakGraphData = (graphData, dateFormat) => {
  const result = [];
  let alertDateTime;

  const format = dateFormat === 'D/M' ? 'DD/M/YY' : 'M/DD/YY';

  for (let i = 0; i < 5; i += 1) {
    const currentDate = moment().subtract((i), 'days').format(format);
    const alertExist = graphData.find((data) => {
      const [alertDate] = Object.keys(data);
      return moment(alertDate).format(format) === currentDate;
    });

    if (alertExist) {
      alertDateTime = Object.keys(alertExist)[0];
    }

    for (let j = 1; j <= 24; j += 1) {
      const alertHour = alertExist && moment(alertDateTime).format('h');
      const hour = alertHour ? Number(alertHour) : 0;
      const leak = hour === j ? 1 : 0;
      result.push({
        x2: currentDate,
        y: leak,
        x: j,
      });
    }
  }

  return result.reverse();
};

export default makeLeakGraphData;
